if (!window.Eurus.loadedScript.has('custom-bundle-subscribe.js')) {
  window.Eurus.loadedScript.add('custom-bundle-subscribe.js');

  class BundleSubscribeAddToCart extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.errorEl = this.querySelector('[data-bundle-subscribe-error]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    async handleClick() {
      if (!this.button || this.button.disabled) return;

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.hideError();
      this.setLoading(true);

      const cartHelper = window.Alpine && window.Alpine.store('xCartHelper') ? window.Alpine.store('xCartHelper') : null;
      const miniCart = window.Alpine && window.Alpine.store('xMiniCart') ? window.Alpine.store('xMiniCart') : null;

      if (cartHelper) {
        await cartHelper.waitForCartUpdate();
      }
      window.updatingCart = true;

      try {
        const sections = cartHelper ? cartHelper.getSectionsToRender().map((section) => section.id) : [];

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections
          })
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          this.showError(data.description || this.dataset.errorMessage);
          return;
        }

        if (cartHelper && data.sections) {
          cartHelper.reRenderSections(data.sections);
          const cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble) {
            cartHelper.currentItemCount = parseInt(cartBubble.innerHTML, 10);
          }
        }

        miniCart?.openCart();
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      } catch (error) {
        console.error('Error:', error);
        this.showError(this.dataset.errorMessage);
      } finally {
        window.updatingCart = false;
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      if (!this.button) return;
      this.button.disabled = isLoading;
      this.button.classList.toggle('is-loading', isLoading);
    }

    showError(message) {
      if (!this.errorEl || !message) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    hideError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
    }
  }

  if (!customElements.get('bundle-subscribe-add-to-cart')) {
    customElements.define('bundle-subscribe-add-to-cart', BundleSubscribeAddToCart);
  }
}
